import { Button } from "@/lib/components/Button/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";

export default function ImageRightsDialog({
  open,
  onOpenChange,
  isSubmitting,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isSubmitting: boolean;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!isSubmitting) onOpenChange(nextOpen);
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader className="w-full">
          <DialogTitle>Confirm image rights</DialogTitle>
          <DialogDescription>
            I confirm I own the images provided for this listing or have the
            rights to use them, including the right to have video created from
            them.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-0 flex-col sm:flex-row">
          <Button isLoading={isSubmitting} onClick={onConfirm}>
            Confirm and pay
          </Button>
          <DialogClose asChild>
            <Button type="button" variant="outline" disabled={isSubmitting}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
